import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class ContaCorrenteVendaParcelaService {

  postVisualizarPorFiltro(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/visualizatodasporfiltro', item, { observe: 'response' })
  }

  getPorId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/visualiza/' + itemId, { observe: 'response' })
  }

  getPorcontaCorrenteId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/visualizaporcontacorrente/' + itemId, { observe: 'response' })
  }

  getPorcontaCorrenteFinanceiroId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/visualizaporcontacorrentefinanceiro/' + itemId, { observe: 'response' })
  }

  post(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/inclui/', item, { observe: 'response' })
  };

  put(item: any, itemId: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/atualiza/' + itemId, item, { observe: 'response' })
  };

  delete(itemId: any): Observable<HttpResponse<any>> {
    return this.http.delete(
      environment.webApiSaguiControlUrl + '/api/contacorrentevendaparcela/exclui/' + itemId, { observe: 'response' })
  }
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
